import axios from 'axios'

function resolveApiBase() {
  if (process.env.VUE_APP_API_BASE) {
    return process.env.VUE_APP_API_BASE
  }
  return '/api'
}

export const API_BASE = resolveApiBase()

const api = axios.create({
  baseURL: API_BASE,
  timeout: 15000,
})

let onAuthExpired = null

export function setAuthExpiredHandler(handler) {
  onAuthExpired = handler
}

export function formatApiError(err, fallback = '操作失败，请稍后重试') {
  if (!err?.response) {
    if (err?.code === 'ECONNABORTED') {
      return '请求超时，请稍后重试'
    }
    return '无法连接后端服务，请先启动后端：npm run start:fastapi'
  }

  const status = err.response.status
  if ([502, 503, 504].includes(status)) {
    return '后端服务未启动，请先运行：npm run start:fastapi'
  }

  const detail = err.response.data?.detail
  if (!detail) {
    if (status === 401) {
      return '用户名或密码错误（默认账号 admin / admin）'
    }
    return fallback
  }
  if (typeof detail === 'string') {
    return detail === 'Invalid credentials' ? '用户名或密码错误（默认账号 admin / admin）' : detail
  }
  if (Array.isArray(detail)) {
    return detail.map((item) => item.msg || item.message || String(item)).join('；')
  }
  return fallback
}

export function setAuthToken(token) {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`
  } else {
    delete api.defaults.headers.common.Authorization
  }
}

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status
    if (status === 401 || status === 403) {
      const hadAuth = Boolean(api.defaults.headers.common.Authorization)
      if (hadAuth && onAuthExpired) {
        onAuthExpired()
      }
    }
    return Promise.reject(error)
  }
)

export const getProjects = () => api.get('/projects')
export const getProject = (id) => api.get(`/projects/${id}`)
export const createAppointment = (data) => api.post('/appointments', data)
export const getAppointments = () => api.get('/appointments')
export const updateAppointmentStatus = (id, status) => api.patch(`/appointments/${id}`, { status })
export const login = (credentials) => api.post('/login', credentials)
export const getNews = () => api.get('/news')
export const getNewsItem = (id) => api.get(`/news/${id}`)
export const createNews = (data) => api.post('/news', data)
export const updateNews = (id, data) => api.put(`/news/${id}`, data)
export const getContactInfo = () => api.get('/contact-info')
export const updateContactInfo = (data) => api.put('/contact-info', data)
export const createMessage = (data) => api.post('/messages', data)
export const getMessages = () => api.get('/messages')
export const updateMessageStatus = (id, status) => api.patch(`/messages/${id}`, { status })
export const translateTexts = (texts, target) =>
  api.post('/translate', { texts, target }, { timeout: 60000 })

export default api
